module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0072.jpg?v=5d117001";